import { render, staticRenderFns } from "./TheOrgCreateAndEditTokenDialog.vue?vue&type=template&id=0c84c735&"
import script from "./TheOrgCreateAndEditTokenDialog.vue?vue&type=script&lang=js&"
export * from "./TheOrgCreateAndEditTokenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports